import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Assign2nr5v5j409ffp as Assign,
  IfNotNull2i0zh8hr8em4r as IfNotNull,
  OnFieldsnrykjjrmtcs as OnField,
  Chainlkbkk6tcx8wg as Chain,
} from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Modification.mjs';
import { nullElementzitp7se36veh as nullElement } from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function modification(serializer, old, new_0) {
  // Inline function 'kotlin.run' call
  var tmp$ret$0;
  $l$block_0: {
    if (equals(old, new_0)) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    if (old == null || new_0 == null) {
      tmp$ret$0 = Assign().l42(new_0);
      break $l$block_0;
    }
    var tmp0_elvis_lhs = nullElement(serializer);
    var tmp1_safe_receiver = get_serializableProperties(tmp0_elvis_lhs == null ? serializer : tmp0_elvis_lhs);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList().w();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$3;
        $l$block_1: {
          if (!isInterface(element, SerializableProperty()))
            THROW_CCE();
          var oldValue = element.k2j(!(old == null) ? old : THROW_CCE());
          var newValue = element.k2j(!(new_0 == null) ? new_0 : THROW_CCE());
          var tmp0_safe_receiver = modification(element.h2j(), oldValue, newValue);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_1;
            var tmp_2;
            if (element.h2j().az().l11()) {
              tmp_2 = !(tmp0_safe_receiver instanceof Assign());
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp_1 = IfNotNull().j42(tmp0_safe_receiver);
            } else {
              tmp_1 = tmp0_safe_receiver;
            }
            tmp_0 = tmp_1;
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp_3;
          if (tmp1_elvis_lhs == null) {
            tmp$ret$3 = null;
            break $l$block_1;
          } else {
            tmp_3 = tmp1_elvis_lhs;
          }
          var inner = tmp_3;
          tmp$ret$3 = OnField().a44(element, inner);
        }
        var tmp0_safe_receiver_0 = tmp$ret$3;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.v(tmp0_safe_receiver_0);
        }
      }
      tmp = Chain().h42(destination);
    }
    var tmp2_elvis_lhs = tmp;
    tmp$ret$0 = tmp2_elvis_lhs == null ? Assign().l42(new_0) : tmp2_elvis_lhs;
  }
  return tmp$ret$0;
}
//region block: exports
export {
  modification as modification1bed5xcrmg3fq,
};
//endregion

//# sourceMappingURL=modification.diff.mjs.map
